var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOriginal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1973",
    "data-name": "Groupe 1973",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.374,
    height: 14.374,
    viewBox: "0 0 14.374 14.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1937",
    "data-name": "Groupe 1937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "verified_FILL1_wght400_GRAD0_opsz24",
    d: "M5.245,13.229,4.184,11.442,2.173,11l.2-2.067L1,7.365,2.368,5.8l-.2-2.067,2.011-.447L5.245,1.5l1.9.81,1.9-.81L10.1,3.287l2.011.447-.2,2.067,1.368,1.564L11.919,8.929l.2,2.067-2.011.447L9.043,13.229l-1.9-.81ZM6.557,9.347,9.713,6.192l-.782-.81L6.557,7.756l-1.2-1.173-.782.782Z",
    transform: "translate(-0.442 0.376)",
    fill: "#174eff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1779",
    "data-name": "Rectangle 1779",
    width: 14.374,
    height: 14.374,
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginal);
export default __webpack_public_path__ + "static/media/original.aa604f505af040d1cb1b598dc3a9e5bc.svg";
export { ForwardRef as ReactComponent };